import { render, staticRenderFns } from "./EmpresaCadastro.vue?vue&type=template&id=06bb4224&"
import script from "./EmpresaCadastro.vue?vue&type=script&lang=js&"
export * from "./EmpresaCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports